import gql from "graphql-tag"
export default {
    ad_place: gql`
        fragment ad_place on ad_place {
            id
            name
            channel_id
            stock
            seq_num
        }
    `,
    board: gql`
        fragment board on board {
            created_at
            status
            ad_time
            ad_place_id
            channel_id
            creator_id
            id
            name
            author_id
            article_type_id
            content_type
            is_lottery
            is_micro
            is_draft
            project_id
            project_money
        }
    `,
    child_board: gql`
        fragment child_board on child_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            created_at
            child_article_type_id
            project_id
            project_money
        }
    `,
    species_board: gql`
        fragment species_board on species_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            is_draft
            created_at
            species_article_type_id
            project_id
            project_money
        }
    `,
    health_board: gql`
        fragment health_board on health_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            is_draft
            created_at
            health_article_type_id
            project_id
            project_money
        }
    `,
    eat_board: gql`
        fragment eat_board on eat_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            created_at
            eat_article_type_id
            project_id
            project_money
            is_draft
        }
    `,
    video_board: gql`
        fragment video_board on video_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            created_at
            project_id
            project_money
        }
    `,
    photo_board: gql`
        fragment photo_board on photo_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            created_at
            photo_article_type_id
            project_id
            project_money
        }
    `,
    beauty_board: gql`
        fragment beauty_board on beauty_board {
            id
            name
            creator_id
            channel_id
            seq_id
            ad_time
            created_at
            beauty_article_type_id
        }
    `,
    channel: gql`
        fragment channel on channel {
            id
            name
            type_name
        }
    `,
    department: gql`
        fragment department on department {
            id
            name
            type_name
            color
        }
    `,
    op_log: gql`
        fragment op_log on op_log {
            ad_place_id
            channel_id
            id
            op_time
            operation
            updated_at
            username
            seq_id
            is_draft
            title
        }
    `,
    role: gql`
        fragment role on role {
            id
            name
        }
    `,
    users: gql`
        fragment users on users {
            uid
            username
            created_at
            department_id
            last_signed_at
            nickname
            password
            role_id
            is_leader
            leader_uid
            mail
        }
    `,
    author: gql`
        fragment author on author {
            id
            name
            uid
            hidden
            user_public {
                nickname
            }
        }
    `,
    article_type: gql`
        fragment article_type on article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    child_article_type: gql`
        fragment child_article_type on child_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    species_article_type: gql`
        fragment species_article_type on species_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    health_article_type: gql`
        fragment health_article_type on health_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    eat_article_type: gql`
        fragment eat_article_type on eat_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    photo_article_type: gql`
        fragment photo_article_type on photo_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    beauty_article_type: gql`
        fragment beauty_article_type on beauty_article_type {
            id
            type_name
            color_code
            name
            hidden
        }
    `,
    operation_person: gql`
        fragment operation_person on operation_person {
            id
            name
            hidden
        }
    `,
    health_operation_person: gql`
        fragment health_operation_person on health_operation_person {
            id
            name
            hidden
        }
    `,
    wechat_board: gql`
        fragment wechat_board on wechat_board {
            id
            seq_id
            author_id
            article_type_id
            creator_id
            description
            ad_time
            created_at
            channel_id
            principal_id
            is_draft
            project_id
            project_money
        }
    `,
    op_person_schedule: gql`
        fragment op_person_schedule on op_person_schedule {
            id
            op_person_id
            op_time
            channel_id
        }
    `,
    health_op_person_schedule: gql`
        fragment health_op_person_schedule on health_op_person_schedule {
            id
            op_person_id
            op_time
        }
    `,
    op_week_schedule: gql`
        fragment op_week_schedule on op_week_schedule {
            id
            name
            op_time
        }
    `,
    species_op_week_schedule: gql`
        fragment species_op_week_schedule on species_op_week_schedule {
            id
            name
            op_time
        }
    `,
    health_op_week_schedule: gql`
        fragment health_op_week_schedule on health_op_week_schedule {
            id
            name
            op_time
        }
    `,
    draft: gql`
        fragment draft on draft {
            id
            description
            author_id
            article_type_id
        }
    `,
    material: gql`
        fragment material on material {
            id
        }
    `,
    board_export: gql`
        fragment board_export on board_export {
            id
            export_year
            export_month
            export_data
        }
    `,
    preset: gql`
        fragment preset on preset {
            id
            seq_id
            author_id
            article_type_id
            description
            ad_weekday
            channel_id
            creator_id
            created_at
        }
    `,
}
